import React from 'react';
import { useFeatureFlags } from '../FeatureFlagContext';
import MenuLink from './MenuLink';
import { StyledMenuItem } from './StyledMenuComponents';
import AccordionSubMenu from './AccordionSubMenu';
export default function NoticesMenu({ outages, roles, hasOpenDepositAccounts, routeInEmber, routeLinks, closeMenu, closeAccordion, activeAccordion, updateAccordionState, }) {
    const featureFlags = useFeatureFlags();
    const { isMortgageEnabled } = featureFlags;
    const shouldRenderBankLink = roles.bank && !outages.bank && hasOpenDepositAccounts;
    const shouldRenderMortgageLink = isMortgageEnabled && roles.mortgage && !outages.mortgage;
    const showAccordion = shouldRenderBankLink && shouldRenderMortgageLink;
    if (showAccordion) {
        return (React.createElement(AccordionSubMenu, { accordionId: "notices", shouldRenderBankLink: shouldRenderBankLink, shouldRenderInvestLink: false, shouldRenderMortgageLink: shouldRenderMortgageLink, instanceKey: "notices-submenu", title: "Notices", ariaLabel: "Notices", linkInfo: routeLinks.notices, routeInEmber: routeInEmber, closeMenu: closeMenu, closeAccordion: closeAccordion, activeAccordion: activeAccordion, updateAccordionState: updateAccordionState }));
    }
    if (shouldRenderMortgageLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.notices.mortgageUrl, text: routeLinks.notices.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "Notices - Home Loans" })));
    }
    if (shouldRenderBankLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.notices.bankUrl, text: routeLinks.notices.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=NoticesMenu.js.map